import script from "./SideMenuClientMultiContacts.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuClientMultiContacts.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuClientMultiContacts.vue?vue&type=style&index=0&id=182d3e53&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-182d3e53"]])

export default __exports__